import React from 'react';
import PlanUnitSelector from 'components/shared/PlanUnitSelector';
import { StyledActionStripBox } from './Toolbar.styles';
import ToolbarAction from './ToolbarAction';
import ToolbarActionMenu from './ToolbarActionMenu';
import { StyledBoxFlexAlignCenter } from 'components/shared/Box/Box.styles';
import { ActionStripProps } from './ActionStrip.types';
import VerticalToolbarActionWrapper from './VerticalToolbarActionWrapper';
import { t } from 'i18next';

// types
import type { ToolbarAction as ToolbarActionType } from '../ToolbarSet.types';

export const ActionStrip: React.FC<ActionStripProps> = React.memo(
  ({ items, justifyEnd, children, planUnitSelector, isVertical }) => {
    const renderAction = (action: ToolbarActionType) => (
      <React.Fragment key={action.id}>
        {action?.contextMenu?.length ? (
          <ToolbarActionMenu action={action} isRightPositioned={isVertical} />
        ) : (
          <ToolbarAction action={action} isRightPositioned={isVertical} />
        )}
      </React.Fragment>
    );

    return (
      <StyledActionStripBox
        component="div"
        isVertical={isVertical}
        justifyEnd={justifyEnd}
      >
        {planUnitSelector?.onSelect && (
          <StyledBoxFlexAlignCenter>
            {isVertical ? (
              <VerticalToolbarActionWrapper
                iconType="grid-list"
                title={t('toolbar.selectPlanUnit')}
                divider={{ bottom: true }}
              >
                <PlanUnitSelector
                  onSelected={planUnitSelector.onSelect}
                  selectedValues={planUnitSelector.selectedValues}
                  isVertical={isVertical}
                  isToolbar
                />
              </VerticalToolbarActionWrapper>
            ) : (
              <PlanUnitSelector
                onSelected={planUnitSelector.onSelect}
                selectedValues={planUnitSelector.selectedValues}
                isToolbar
              />
            )}
          </StyledBoxFlexAlignCenter>
        )}
        {items?.map(renderAction)}
        {children}
      </StyledActionStripBox>
    );
  }
);
